var urlRegExp = /^(?:(ftp||http(s)?||file):\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
/**@type {import("./types").FormFieldValidator} */

export default (function (value) {
  var error = urlRegExp.test(value) ? '' : 'URL is invalid';
  return error;
});